module.exports = __webpack_public_path__ + "img/feature_buy_zh.86b2913d.png";